import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'allocations',
    component: () => import('@/app/modules/allocations/views/allocations-index.vue'),
    children: [
      {
        path: '',
        component: () => import('@/app/modules/allocations/views/allocations-groups.vue'),
        meta: {
          layoutFeatures: {
            actionPanel: false,
          },
        },
      },
      {
        path: 'upload',
        component: () => import('@/app/modules/allocations/views/allocations-upload.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
      {
        path: 'create-group',
        component: () => import('@/app/modules/allocations/views/allocations-group-creation.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
      {
        path: 'groups/:id',
        component: () => import('@/app/modules/allocations/views/allocations-group.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
      {
        path: 'approved',
        component: () => import('@/app/modules/allocations/views/allocations-approved.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
      {
        path: 'pending',
        component: () => import('@/app/modules/allocations/views/allocations-pending.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
      {
        path: 'comparable-products/:id',
        component: () =>
          import('@/app/modules/allocations/views/allocations-comparable-products.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
    ],
  },
];
export default routes;
